document.addEventListener('DOMContentLoaded', () => {

    const collectionPage = document.querySelector('.page-template-template-collections')
    const collectionDetailPage = document.querySelector('.tax-pa_collection')
    const projectsPage = document.querySelector('.post-type-archive-project')

    if (collectionPage !== null || projectsPage !== null || collectionDetailPage !== null) {
        if (window.innerWidth < 1023) {

            document.querySelectorAll('.js-filter-screen-toggle').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    const filterScreen = document.querySelector('.c-mobile-filter-screen')
                    const documentBody = document.body

                    if (filterScreen.classList.contains('open')) {
                        filterScreen.classList.remove('open')
                        documentBody.classList.remove('no-scroll')
                        return
                    }

                    if (!filterScreen.classList.contains('open')) {
                        filterScreen.classList.add('open')
                        documentBody.classList.add('no-scroll')
                    }
                })
            })


            const mobileFilterBtn = document.querySelector('.c-mobile-filter-toggle')
            const headerHeight = document.querySelector('.l-mobile-header').offsetHeight
            const parentDiv = document.querySelector('.js-mobile-filter-toggle-parent')

            setMobileFilterScrollClass(mobileFilterBtn, headerHeight, parentDiv)

            window.addEventListener('scroll', function () {
                setMobileFilterScrollClass(mobileFilterBtn, headerHeight, parentDiv)
            })

            function setMobileFilterScrollClass(mobileFilterBtn, headerHeight, parentDiv) {
                let parentDivPositionY = parentDiv.getBoundingClientRect().top

                if (parentDivPositionY - 50 <= headerHeight) {
                    mobileFilterBtn.classList.add('c-mobile-filter-toggle--scroll')
                }

                if (parentDivPositionY > headerHeight) {
                    mobileFilterBtn.classList.remove('c-mobile-filter-toggle--scroll')
                }
            }

        }
    }
});